import React, { useState } from 'react';
import image1 from '../images/push-right.png';
import image2 from '../images/push-rightinner.png';
import RightFilterToggleContent from './RightFilterContent';
export default function RightFilterToggle(props) {
    const [style, setStyle] = useState(" right-toggle-content filter-toggle ms-3");
    const [slide, setSlide] = useState({display: 'none'});
    const [flag, setflag] = useState(false);   
    const changeStyle = () => { 
        if (flag) {
            setStyle("right-toggle-content filter-toggle ms-3");
            setSlide({display: 'none'});
        }
        else {
            
            setSlide({display: 'block'});
            setStyle("right-toggle-content filter-hide ms-3"); 
             
        }

        setflag(!flag);
    };

    const searchOnClick = (customerKey, carrierKey, startDate, endDate, freightBillNumber, accountNumber) => {
        props.onSearchClick(customerKey, carrierKey, startDate, endDate, freightBillNumber, accountNumber);

    }

    const customerOnChange = (customerKey, carrierKey, startDate, endDate, freightBillNumber, accountNumber) => {
        props.onCustomerChange(customerKey, carrierKey, startDate, endDate, freightBillNumber, accountNumber);

    }

    return (
        <>
            <div className='sticky-right'>  
                <a href='#' className='toggle-panel' onClick={changeStyle} style={slide}><img src={image1}></img></a>
                <div className={style}>
                    <div className='panel-header d-flex justify-content-between p-2'>
                        <span >Filter</span> 
                        <a href='#' className='' onClick={changeStyle}><img src={image2}></img></a>
                    </div>
                    <div className='panel-body p-2 border-top-0 border rounded-bottom' style={{ height: "665px" }}>
                        <RightFilterToggleContent onSearchClick = {searchOnClick} onCustomerChange = {customerOnChange} isFbNoDisabled={props.isFbNoDisabled} isAccNoDisabled={props.isAccNoDisabled} customer_key={props.topFilterCustKey}  />
                    </div>
                </div>
            </div>

        </>

    )
}
